import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchReviewById(id) {
  const { data } = await http(`/admin/product-reviews/${id}`);

  return data;
}

export function useReviewById(id) {
  const { data, ...raResult } = useQuery(["product-review-detail", id], () =>
    fetchReviewById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

async function toggleReview({id}) {
  const data = await http(`/admin/product-reviews/${id}/toggle`, {
    method: "POST"
  });
  return data;
}

export function useToggleReview({id}) {
  const queryClient = useQueryClient();

  return useMutation(toggleReview, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-review-detail", id]);
    },
  });
}
